import {
  Directive,
  OnInit,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
    Renderer,
    Optional
} from '@angular/core';
import { NgControl } from "@angular/forms";

declare var $: any;

@Directive({
  selector: '[csSelect2]',
  inputs: ['select2Config'],
})

export class CsSelect2Directive implements OnInit {
  @Input('placeholder') placeholder: string = '-- Please choose --';
  @Input('dropdownvalue') value: any = '';
    @Input() saveTextAsFormValue: boolean = false;
  @Output('selected') valueEmitter: EventEmitter<any> = new EventEmitter();
  @Output('opened') opened: EventEmitter<any> = new EventEmitter();
  @Output() $instance: EventEmitter<any> = new EventEmitter();
  @Output('onChange') onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output('onChoiceSelected') choiceSelected = new EventEmitter<{data: object, jQEl: object}>();
  select2Config: any;
  select2: any;

  constructor(
    private _hostRef: ElementRef,
    private _renderer: Renderer,
    @Optional() private control: NgControl,
  ) {
  }

  ngOnInit() {
      // console.log(this.value);
      this.select2Config['placeholder'] = this.placeholder;
  }

    // sanitise string to convert it to a valid HTML ID
    sanitiseStringToId(str: string): string {
        return str ? str.replace(/[^a-zA-Z0-9-_]/g, '_') : str;
    }

    ngAfterViewInit() {
        if (this.control && this.value === '') {
            this.value = this.control.control.value;
        }

        this.select2 = $(this._hostRef.nativeElement)
            .select2(this.select2Config)
            .select2('val', this.saveTextAsFormValue ? this.sanitiseStringToId(this.value) : this.value);

        this.select2.on('select2-selected', (event) => {
            this.valueEmitter.emit(event.val);
            if (this.control) {
                this.control.control.setValue(event.val);
            }
        });

        this.select2.on('change', (event) => {
            this.valueEmitter.emit(event.val);
            this.onChange.emit(event.val);
        });

        this.select2.on('select2-open', (event) => {
            this.opened.emit(true);
            if (this.control) {
                this.control.control.markAsTouched();
            }
        });

        this.select2.on('choice-selected', (event, s2Container, selectedEl) => {
            const existingSelectedEl = s2Container.find('.s2-choice-active');
            const jQSelectedEl = $(selectedEl);
            const selectedData = $(selectedEl).data('select2-data');

            if (existingSelectedEl && selectedEl && (existingSelectedEl[0] !== $(selectedEl)[0])) {
                existingSelectedEl.removeClass('s2-choice-active');
            }

            $(selectedEl).addClass('s2-choice-active');

            this.choiceSelected.emit({data: selectedData, jQEl: jQSelectedEl});
        });

        this.$instance.emit(this.select2);
    }
}
